export interface SubPermissionKeys {
  uploadCertificate: string;
}

export const subPermissionKeys: SubPermissionKeys = {
  uploadCertificate: 'users-store-cert',
};
